import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { z } from 'zod';
import { createPredicateSchema } from '@/entities/predicate';
import { zodCamelCaseString } from '@/shared/lib';
import { AttributeGroupFormValues } from './types';

const createSchema = (t: TFunction<readonly ['attributeGroups', 'common']>) => {
  return z.object({
    name: z
      .string({ error: t('common:required') })
      .min(1, t('common:required'))
      .max(150, t('common:maxLength', { count: 150 })),
    code: zodCamelCaseString({
      message: t('common:codeMustBeCamelCase'),
      minLength: 1,
    }),
    description: z.string(),
    attributes: z.array(
      z.object({
        code: z.string(),
      }),
    ),
    predicate: createPredicateSchema(t('common:predicateHasIssues')),
  }) satisfies z.ZodType<AttributeGroupFormValues>;
};

export const useAttributeGroupSchema = () => {
  const { t } = useTranslation(['attributeGroups', 'common']);

  return createSchema(t);
};
